module.exports = __webpack_public_path__ + "static/media/thumbnail.daa83f0d.jpg";